import { render, staticRenderFns } from "./DeleteCoEModal.vue?vue&type=template&id=256048c2&"
import script from "./DeleteCoEModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCoEModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCoEModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports